<template lang="pug">
  .login-page
    .wrapper.wrapper-full-page
      .full-page.login-page.section-image
        .content
          BContainer
            BCol.ml-auto.mr-auto(lg="4" md="6")
              .info-area.info-horizontal.mt-5
                .icon.icon-danger
                  i.nc-icon.nc-alert-circle-i
                .description
                  h2.text-white.mt-3 {{ messages[code].title }}
                  small.text-white
                    | {{ messages[code].message }} <br> {{ $t('error.goto') }}
                    |
                    RouterLink(to="/") {{ $t('error.to-main') }}
        .full-page-background(:style="{ backgroundImage: `url(${backgroundImage})` }")
</template>

<script>
export default {
  props: {
    code: { type: Number, required: true }
  },
  data: (vm) => ({
    messages: {
      403: {
        title: vm.$t('error.403.title'),
        message: vm.$t('error.403.message')
      },
      404: {
        title: vm.$t('error.404.title'),
        message: vm.$t('error.404.message')
      },
      500: {
        title: vm.$t('error.500.title')
      }
    }
  }),
  computed: {
    backgroundImage: () => require('@/assets/img/background/background-errors.jpg')
  }
}
</script>
